import { render, staticRenderFns } from "./FaradayDiskViz.vue?vue&type=template&id=0231d149&scoped=true"
import script from "./FaradayDiskViz.vue?vue&type=script&lang=js"
export * from "./FaradayDiskViz.vue?vue&type=script&lang=js"
import style0 from "./FaradayDiskViz.vue?vue&type=style&index=0&id=0231d149&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0231d149",
  null
  
)

export default component.exports